var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebhook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 150,
    viewBox: "0 0 350 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 150,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9013 53.761L83.6207 95.9317L94.8183 90.5268L101.394 53.761H86.9061",
    fill: "#00D186"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.285 53.761H114.681L102.784 68.6585L108.285 72.4488L133.29 53.7659L133.285 53.761Z",
    fill: "#D1D7DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.559 43.9073L103.654 41.1512L86.9061 53.761H133.285L122.559 43.9073Z",
    fill: "#353E44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.266 89.6439L102.784 68.6585L101.117 77.8537L118.613 96.8488L133.266 89.6439Z",
    fill: "#3DADDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171 51.3333L168.063 54.2708L179.688 65.9167H154.333V70.0833H179.688L168.063 81.7292L171 84.6667L187.667 68L171 51.3333Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.667 53H264.667V47.6667H216.667C213.733 47.6667 211.333 50.0667 211.333 53V82.3333H206V90.3333H243.333V82.3333H216.667V53ZM267.333 58.3333H251.333C249.867 58.3333 248.667 59.5333 248.667 61V87.6666C248.667 89.1333 249.867 90.3333 251.333 90.3333H267.333C268.8 90.3333 270 89.1333 270 87.6666V61C270 59.5333 268.8 58.3333 267.333 58.3333ZM264.667 82.3333H254V63.6667H264.667V82.3333Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhook);
export default __webpack_public_path__ + "static/media/webhook.5d154c2044de8e9d80174d7c664bfb11.svg";
export { ForwardRef as ReactComponent };